export default "__VITE_ASSET__DQ3bqbnz__"